import DelayedTask from './DelayedTask';

export default DelayedTask;
